export default __webpack_public_path__ + "28772be32f35fba8092561f2511cf3f7.svg";